import React from 'react';

import { Skeleton } from '@mui/material';

import { CommonStyles } from '@kamernet/styles/CommonStyles';

export const ContentCityGenericSkeleton = () => {
  return (
    <React.Fragment>
      <Skeleton
        variant="rectangular"
        width="90%"
        height={56}
        className={CommonStyles.margin_block_2}
      />
      <Skeleton
        variant="text"
        width="100%"
        height={28}
        className={CommonStyles.margin_top_1}
      />
      <Skeleton variant="text" width="100%" height={28} />
      <Skeleton
        variant="text"
        width="80%"
        height={28}
        className={CommonStyles.margin_bottom_1}
      />

      <Skeleton
        variant="rectangular"
        width="60%"
        height={36}
        className={CommonStyles.margin_block_2}
      />
      <Skeleton
        variant="text"
        width="100%"
        height={28}
        className={CommonStyles.margin_top_1}
      />
      <Skeleton variant="text" width="100%" height={28} />
      <Skeleton variant="text" width="100%" height={28} />
      <Skeleton
        variant="text"
        width="80%"
        height={28}
        className={CommonStyles.margin_bottom_1}
      />

      <Skeleton
        variant="rectangular"
        width="50%"
        height={36}
        className={CommonStyles.margin_block_2}
      />
      <Skeleton
        variant="text"
        width="100%"
        height={28}
        className={CommonStyles.margin_top_1}
      />
      <Skeleton variant="text" width="100%" height={28} />
      <Skeleton variant="text" width="100%" height={28} />
      <Skeleton
        variant="text"
        width="80%"
        height={28}
        className={CommonStyles.margin_bottom_1}
      />
    </React.Fragment>
  );
};
